var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSadBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 18.5923C8 11.1241 14.1268 5 21.681 5H50.2893C57.8455 5 63.9645 11.1238 64 18.5819L64 18.5923L64 60.1359C64 63.2869 62.8514 66.0746 60.4035 67.507C57.9551 68.9396 54.9462 68.5839 52.1764 67.052M52.1764 67.052L37.6745 59.0508C37.3375 58.8605 36.7411 58.6985 36.0111 58.6985C35.2834 58.6985 34.6706 58.8596 34.3093 59.0598L19.8236 67.052L19.8166 67.0558C17.0439 68.5726 14.0389 68.9139 11.5965 67.4849C9.15244 66.0548 8 63.2781 8 60.1359V18.5923M21.681 9.42266C16.5928 9.42266 12.4515 13.5592 12.4515 18.5923V60.1359C12.4515 62.3008 13.2132 63.2982 13.8555 63.674C14.4992 64.0506 15.7516 64.2298 17.6659 63.1836C17.6671 63.1829 17.6682 63.1823 17.6694 63.1816L32.1411 55.1972C32.1406 55.1974 32.1416 55.1969 32.1411 55.1972C33.3227 54.5429 34.7288 54.2758 36.0111 54.2758C37.2878 54.2758 38.6898 54.5399 39.8641 55.2001L54.3376 63.1855C56.256 64.2471 57.5072 64.069 58.1444 63.6961C58.7829 63.3225 59.5485 62.3215 59.5485 60.1359V18.5982C59.5221 13.5569 55.3739 9.42266 50.2893 9.42266H21.681Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 24.2058C28.8807 24.2058 30 25.3251 30 26.7058V31.7058H25V26.7058C25 25.3251 26.1193 24.2058 27.5 24.2058Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5 24.2058C45.8807 24.2058 47 25.3251 47 26.7058V31.7058H42V26.7058C42 25.3251 43.1193 24.2058 44.5 24.2058Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 41.7058C33.2386 41.7058 31 43.9444 31 46.7058H27C27 41.7352 31.0294 37.7058 36 37.7058C40.9706 37.7058 45 41.7352 45 46.7058H41C41 43.9444 38.7614 41.7058 36 41.7058Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadBoard);
export default __webpack_public_path__ + "static/media/sadBoard.d610aca8.svg";
export { ForwardRef as ReactComponent };